"use client";
import { HeaderProps, LinkProps } from "@/utils/types";
import { WaveBorder } from "../WaveBorder";
import Link from "next/link";
import { NavToggle } from "./NavToggle";
import { useState } from "react";
import { X } from "@phosphor-icons/react";
import { Foods } from "../Foods";
import { ImageObject } from "../modules/ImageObject";

const Item = ({ copy, href }: LinkProps) => (
  <span className="block font-display lg:w-full lg:max-w-[150px] text-white text-[18px] relative lg:top-7">
    <Link href={href}>{copy}</Link>
  </span>
);

export const Header = ({
  mainNav,
  logo,
  donate,
  noScroll,
  flat,
  donateButton,
}: HeaderProps) => {
  const [open, setOpen] = useState(false);

  const NavContent = () => {
    return (
      <div className="inner flex items-center gap-10 w-full justify-center px-4">
        <div className="md:hidden flex w-full items-center justify-between">
          <Link
            href="/"
            className="block md:hidden w-[50px]"
            onClick={() => {
              document.body.style.overflow = "auto";
              setOpen(false);
            }}
          >
            <ImageObject
              {...logo}
              imageWidth={100}
              alt="Urban Seeds Logo"
              className="w-[107px]"
            />
          </Link>
          <NavToggle
            className="block md:hidden relative z-50"
            onClick={() => {
              setOpen(!open);
              if (open) {
                document.body.style.overflow = "auto";
              } else {
                document.body.style.overflow = "hidden";
              }
            }}
          />
        </div>
        <nav>
          <Link
            href="/"
            className="hidden md:block lg:hidden w-[80px]"
            onClick={() => {
              document.body.style.overflow = "auto";
              setOpen(false);
            }}
          >
            <ImageObject
              {...logo}
              imageWidth={200}
              alt="Urban Seeds Logo"
              className="w-[107px]"
            />
          </Link>
          {mainNav.slice(0, 3).map((item) => (
            <Item key={item.copy} {...item} />
          ))}
          <Link
            href="/"
            className="hidden lg:block w-[107px]"
            onClick={() => {
              document.body.style.overflow = "auto";
              setOpen(false);
            }}
          >
            <ImageObject
              {...logo}
              imageWidth={500}
              alt="Urban Seeds Logo"
              className="w-[107px]"
            />
          </Link>
          {mainNav.slice(3, 6).map((item) => (
            <Item key={item.copy} {...item} />
          ))}
        </nav>
      </div>
    );
  };
  return (
    <header
      className={`text-center border-b-[12px] md:border-b-0 border-t-[12px] md:border-t-[24px] lg:border-t-[12px] border-primary relative${noScroll ? "" : " mb-[67px] md:mb-[124px]"} z-50`}
    >
      {flat ? (
        <div className="bg-primary pb-4">
          <NavContent />
        </div>
      ) : (
        <WaveBorder flip className="reverse">
          <NavContent />
        </WaveBorder>
      )}
      {donateButton && (
        <a
          href={donate.href}
          onClick={() => {
            document.body.style.overflow = "auto";
            setOpen(false);
          }}
          target="_blank"
          rel="noopener noreferrer"
          className="button secondary fixed xl:absolute xl:top-3 2xl:right-20 right-5 bottom-8 xl:bottom-auto z-10 shadow-lg xl:shadow-none"
        >
          {donate.copy}
        </a>
      )}
      <div
        className={`mobile-nav ${
          open ? "open" : "closed"
        } flex md:hidden justify-center items-center top-0 left-full w-full h-svh bg-whiteTransparent fixed z-10 flex-col pointer-events-none transition-[left] gap-4 ease-in-out`}
      >
        <button
          onClick={() => {
            setOpen(!open);
            if (open) {
              document.body.style.overflow = "auto";
            } else {
              document.body.style.overflow = "hidden";
            }
          }}
          className="button absolute top-0 right-0 bg-secondary"
          style={{
            borderRadius: 0,
            paddingLeft: "1.25rem",
            paddingRight: "1.25rem",
          }}
        >
          <X size={40} />
          <span className="hidden">Close</span>
        </button>
        {mainNav.map((item) => (
          <Link
            href={item.href}
            onClick={() => {
              document.body.style.overflow = "auto";
              setOpen(false);
            }}
            key={item.copy}
            className="bg-primary px-5 pt-2 pb-[9px] shadow-lg hover:bg-primaryShade rounded-lg"
          >
            <span className="block font-display lg:w-full lg:max-w-[150px] text-white text-4xl relative lg:top-7">
              {item.copy}
            </span>
          </Link>
        ))}
      </div>
      {!noScroll && <Foods bottom className="top-full mt-4 md:mt-0" />}
    </header>
  );
};
